import axios from "axios";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import logo from "../../assets/images/committee-logo.jpeg";
import "./login.css";

const Login = ({ setIsAuthenticated }) => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const sumbitLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post("api/auth/user/login", {
        login: username,
        password,
      })
      .then((res) => {
        if (res.data.access_token) {
          Cookies.set("role", res.data.role, { expires: 1 });
          Cookies.set("token", res.data.access_token, { expires: 1 });
          setIsAuthenticated(true);
        } else {
          toast.error(res.data.detail, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="login-component">
      <div className="login-wrapper">
        <div className="login-header">
          <img src={logo} alt="Oziq-ovqat xavfsizligi qo'mitasi" />
          <h2>Tizimga kirish</h2>
          <p>Hisobot tizimiga xush kelibsiz!</p>
        </div>
        <form onSubmit={sumbitLogin}>
          <div className="input-group">
            <label>Login</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Loginni kiriting"
            />
          </div>
          <div className="input-group">
            <label>Maxfiy so'z</label>
            <div className="password-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Maxfiy so'zni kiriting"
              />
              <button
                type="button"
                className="eye-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <IoEyeOffOutline className="eye-icon" />
                ) : (
                  <IoEyeOutline className="eye-icon" />
                )}
              </button>
            </div>
          </div>
          <button type="submit" className="load" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : null}
            <span style={{ marginLeft: loading ? "8px" : "0" }}>
              {loading ? "Kirilmoqda..." : "Kirish"}
            </span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
